import { render, staticRenderFns } from "./ClienteEditDialog.vue?vue&type=template&id=57128d68"
import script from "./ClienteEditDialog.vue?vue&type=script&lang=ts"
export * from "./ClienteEditDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports